module.exports = __webpack_public_path__ + "static/media/logo.81e3c34c.png";